import React from 'react';
import { Alert } from 'react-bootstrap';

const VARIANT_STYLE = {
  warning: {
    backgroundColor: 'var(--color-warning-bg)',
    borderColor: 'var(--color-warning)',
    color: 'var(--color-accent-text)',
  },
  info: {
    backgroundColor: 'var(--color-surface)',
    borderColor: 'var(--color-border)',
    color: 'var(--color-text-secondary)',
  },
};

export default function WarningAlert({ children, className, variant = 'warning' }) {
  return (
    <Alert
      className={className}
      style={VARIANT_STYLE[variant] || VARIANT_STYLE.warning}
    >
      {children}
    </Alert>
  );
}
